import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/easm-settings')({
  beforeLoad: () => getTitleContextSlice('EASM-Settings'),
  staticData: {
    owner: CodeOwner.Identities,
  },
});
